import { FC, useContext } from 'react'
import { AccountsReceivableContext } from '../../../context/AccountsReceivableContext'
import { formatCurrency } from '../../../utils'
import { Box, Typography } from '@mui/material'
import { flexCenter, flexJustifySpaceBetween } from '../../../theme/styleConstants'

const AccountsReceivableSummary: FC = () => {
  const { arEntriesSummary } = useContext(AccountsReceivableContext)

  if (!arEntriesSummary) return null

  const summary = [
    {
      name: 'Total ARs',
      total: formatCurrency(arEntriesSummary.totalARs || 0)
    },
    {
      name: 'Total Invoiced',
      total: formatCurrency(arEntriesSummary.totalInvoiced || 0)
    }
  ]

  return (
    <Box sx={{ ...flexCenter, gap: 4, my: 2 }}>
      {summary.map(({ name, total }) => (
        <Box key={name} sx={{ backgroundColor: 'white', px: 2, py: 3, flex: 1 }}>
          <Box sx={{ ...flexCenter, ...flexJustifySpaceBetween }}>
            <Typography color="gray900" fontSize={18}>
              {name}
            </Typography>
            <Typography color="secondary.main" fontSize={26}>
              {total}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default AccountsReceivableSummary
